import { createSlice } from '@reduxjs/toolkit';

import { applyStateupdate } from '../utils';

interface UserState {
    'state/user': object;
    'state/releaseNotesLastCheckedVersion': string | null;
    'state/guidedTourIsSeen': boolean;
    'state/tourCompleted': boolean;
    'state/runGuidedTour': boolean;
    'state/userRole': object;
    'state/isAdminOnlyBgShow': boolean;
    'state/isadmin': boolean;
    'state/isConversationErrBoundary': boolean;
}

export const initState: UserState = {
    'state/user': {},
    'state/releaseNotesLastCheckedVersion': null,
    'state/guidedTourIsSeen': false,
    'state/tourCompleted': false,
    'state/runGuidedTour': false,
    'state/userRole': {},
    'state/isAdminOnlyBgShow': false,
    'state/isadmin': false,
    'state/isConversationErrBoundary': false,
};

export const userSlice = createSlice({
    name: 'state',
    initialState: initState,
    reducers: {
        user: (state, action) => {
            return applyStateupdate(state, action);
        },
        releaseNotesLastCheckedVersion: (state, action) => {
            return applyStateupdate(state, action);
        },
        guidedTourIsSeen: (state, action) => {
            return applyStateupdate(state, action);
        },
        tourCompleted: (state, action) => {
            return applyStateupdate(state, action);
        },
        runGuidedTour: (state, action) => {
            return applyStateupdate(state, action);
        },
        userRole: (state, action) => {
            const newState = applyStateupdate(state, action);
            newState['state/isadmin'] = newState['state/userRole']?.data?.role === 'Admin';
            return newState;
        },
        isAdminOnlyBgShow: (state, action) => {
            return applyStateupdate(state, action);
        },
        isConversationErrBoundary: (state, action) => {
            return applyStateupdate(state, action);
        },
    },
});

export default userSlice;
